import { Node } from './node';


export class ExecutionPath {
  constructor(
  public executedGatewaysIds: string[] = [],
  public executedTreatmentTaskId?: string,
  public gatewayIdToNodesToSelect?: string,
  public executedConnectionsIds: string[] = [],
  public connectionsToActivitiesForSelectionIds: string[] = [],
  public nodesForSelection: Node[] = [],
  public executedNodes?: Node[],
  public currentUserTaskHolder?: Node) { }
  public userSelectedElement?: string
}
